// Ported from the Polaris kit: src/components/ui/sidebar/index.js.
// Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
// Change the design in the kit first, then re-port.
import { cva } from 'class-variance-authority';

export { default as Sidebar } from './Sidebar.vue';
export { default as SidebarContent } from './SidebarContent.vue';
export { default as SidebarFooter } from './SidebarFooter.vue';
export { default as SidebarGroup } from './SidebarGroup.vue';
export { default as SidebarGroupAction } from './SidebarGroupAction.vue';
export { default as SidebarGroupContent } from './SidebarGroupContent.vue';
export { default as SidebarGroupLabel } from './SidebarGroupLabel.vue';
export { default as SidebarHeader } from './SidebarHeader.vue';
export { default as SidebarInput } from './SidebarInput.vue';
export { default as SidebarInset } from './SidebarInset.vue';
export { default as SidebarMenu } from './SidebarMenu.vue';
export { default as SidebarMenuAction } from './SidebarMenuAction.vue';
export { default as SidebarMenuBadge } from './SidebarMenuBadge.vue';
export { default as SidebarMenuButton } from './SidebarMenuButton.vue';
export { default as SidebarMenuItem } from './SidebarMenuItem.vue';
export { default as SidebarMenuSkeleton } from './SidebarMenuSkeleton.vue';
export { default as SidebarMenuSub } from './SidebarMenuSub.vue';
export { default as SidebarMenuSubButton } from './SidebarMenuSubButton.vue';
export { default as SidebarMenuSubItem } from './SidebarMenuSubItem.vue';
export { default as SidebarProvider } from './SidebarProvider.vue';
export { default as SidebarRail } from './SidebarRail.vue';
export { default as SidebarSeparator } from './SidebarSeparator.vue';
export { default as SidebarTrigger } from './SidebarTrigger.vue';

export { useSidebar } from './utils';

export const sidebarMenuButtonVariants = cva(
  'peer/menu-button flex w-full items-center gap-2 overflow-hidden rounded-polaris-md p-2 text-left type-polaris-label outline-none ring-polaris-sidebar-ring transition-[width,height,padding] hover:bg-polaris-sidebar-accent hover:text-polaris-sidebar-accent-foreground focus-visible:ring-[2px] active:bg-polaris-sidebar-accent active:text-polaris-sidebar-accent-foreground disabled:pointer-events-none disabled:opacity-50 group-has-[[data-sidebar=menu-action]]/menu-item:pr-8 aria-disabled:pointer-events-none aria-disabled:opacity-50 data-[active=true]:bg-polaris-sidebar-accent data-[active=true]:text-polaris-sidebar-accent-foreground data-[state=open]:hover:bg-polaris-sidebar-accent data-[state=open]:hover:text-polaris-sidebar-accent-foreground group-data-[collapsible=icon]:!size-8 group-data-[collapsible=icon]:!p-2 [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0',
  {
    variants: {
      variant: {
        default:
          'hover:bg-polaris-sidebar-accent hover:text-polaris-sidebar-accent-foreground',
        outline:
          'bg-polaris-background shadow-[0_0_0_1px_var(--polaris-sidebar-border)] hover:bg-polaris-sidebar-accent hover:text-polaris-sidebar-accent-foreground hover:shadow-[0_0_0_1px_var(--polaris-sidebar-accent)]',
      },
      size: {
        default: 'h-8',
        sm: 'h-7',
        lg: 'h-12 group-data-[collapsible=icon]:!p-0',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);
